const selectYesNoOptions = [
  { id: true, name: 'Sim' },
  { id: false, name: 'Não' },
];

export default selectYesNoOptions;
